import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.SplitView.Pagination', {
    buttonPreviousTitle: 'Previous document',
    buttonNextTitle: 'Next document',
    paginationText: '{currentIndex} of {total}',
});
